import request from '@/utils/request';

// 获取列表
export function GetList(params) {
    return request({
        url: '/api/order/my/pageDelete',
        method: 'GET',
        params: params
    });
}
// 再来一单
export function GetOrderSku(params) {
    return request({
        url: '/api/good/getOrderSku',
        method: 'GET',
        params: params
    });
}